
export default function LegalSection() {
  return (
    <div className="py-8 md:py-10 ">
      <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-lg p-8 md:p-14 mb-8 text-center">
        <h2 className="text-xl md:text-4xl font-bold text-white mb-4">
          ARE ONLINE CASINOS LEGAL IN AUSTRALIA?
        </h2>
        <div className="w-full h-full mt-4 md:mt-8 rounded-lg overflow-hidden">
          <img 
            src="/202512162902219.png" 
            alt="Legal Online Casinos Australia" 
            className="w-full h-full object-contain"
          />
        </div>
      </div>
      
      <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-lg mb-6">
        <p className="text-sm md:text-base text-gray-800 font-semibold italic leading-relaxed">
          The legal landscape of online gambling in Australia is complex and nuanced. While the Interactive Gambling Act 2001 prohibits Australian-based companies from offering online casino services to Australian residents, it does not make it illegal for Australian players to access and play at offshore online casinos licensed in other jurisdictions.
        </p>
      </div>
      
      <div className="bg-gray-50 p-6 rounded-lg">
        <p className="text-base text-gray-700 leading-relaxed">
          <strong className="font-bold">Disclaimer:</strong> This information is provided for educational purposes only and should not be construed as legal advice. The legal status of online gambling can vary and may change over time. Australian players should be aware that while playing at offshore casinos is not explicitly illegal under current federal law, they do so at their own discretion and risk. We strongly recommend that players only engage with licensed and regulated online casinos that operate under reputable international gaming authorities such as Curacao Gaming Authority (CGA) and the UK Gambling Commission. Always gamble responsibly and within your means. If you have concerns about problem gambling, please seek help from organizations like Gambling Help Online or contact the National Gambling Helpline at 1800 858 858.
        </p>
      </div>
    </div>
  );
}
